<template>
  <section class="container-page" v-if="item">
    <h2 class="title-inner">Карточка экспортного потенциала товара</h2>

    <template v-if="isAccessAllowed">
      <div class="row">
        <div class="form-group disabled-select">
          <ComponentInput label="Код ТН ВЭД ЕАЭС" v-model="item.tnvedCode" type="number" disabled />
        </div>
      </div>
      <div class="row">
        <div class="form-group disabled-select">
          <ComponentInput label="Наименование товара" v-model="item.tnvedName" type="text" disabled />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-6">
          <ComponentInput label="Экспортный потенциал, млн долл." v-model="item.potentialValue" type="number" />
        </div>
        <div class="form-group col-6">
          <ComponentInput
            label="Фактический экспорт России в страну, млн долл."
            v-model="item.exportFactToCountry"
            type="number"
            disabled
          />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-6">
          <ComponentInput
            label="Фактический экспорт России во все страны, млн долл."
            v-model="item.exportFactWorld"
            type="number"
            disabled
          />
        </div>
        <div class="form-group col-6">
          <ComponentInput
            label="Фактический импорт страны из всех стран, млн долл."
            v-model="item.importFromCountry"
            type="number"
            disabled
          />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-6">
          <ComponentInput label="Страна-импортер" v-model="item.countryName" type="text" disabled />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-6">
          <ComponentInput label="Период экспорта России" v-model="item.exportYear" type="number" disabled />
        </div>
        <div class="form-group col-6">
          <ComponentInput label="Период импорта страны-партнера" v-model="item.importYear" type="number" disabled />
        </div>
      </div>

      <div class="mb-16">
        <ButtonComponent mod="gradient-bg" class="mr-8" @click="save">Сохранить</ButtonComponent>
        <ButtonComponent mod="border" @click="close">Отмена</ButtonComponent>
      </div>
    </template>
  </section>
</template>

<script>
  import ComponentInput from '@/common/components/ComponentInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import CountryApi from '@/modules/nsi/api/country';

  import { createPotentialApi } from '../api/potentialCardApi';

  const Api = createPotentialApi('exportpotential');

  const PERMISSIONS = {
    edit: Constants.Permissions.ExportPotentialEdit,
  };

  export default {
    name: 'ExportPotentialCard',
    components: { ComponentInput, ButtonComponent },
    mixins: [security],
    data() {
      return {
        id: Number(this.$route.params.id),
        exportId: Number(this.$route.query.exportId) || null,
        importId: Number(this.$route.query.importId) || null,
        item: null,
        countries: [],
        defaultRequest: {
          pageNumber: 1,
          pageSize: 0,
        },
      };
    },
    created() {
      this.checkPermissionAndRedirect(PERMISSIONS.edit).then((isAllowed) => {
        if (!isAllowed) return;

        this.loadDictionaries();
        this.loadCard();
      });
    },
    methods: {
      loadCard() {
        const params = {
          potentialId: this.id,
          ...(isFinite(this.exportId) && { exportId: this.exportId }),
          ...(isFinite(this.importId) && { importId: this.importId }),
        };
        Api.find(params).then((response) => {
          this.item = response.data;
        });
      },
      loadDictionaries() {
        CountryApi.search(this.defaultRequest).then((response) => {
          this.countries = response.data.items.map((item) => ({ text: item.name, id: item.id }));
        });
      },
      save() {
        const item = this.item;
        if (!item) return;
        const body = {
          potentialId: this.id,
          exportId: this.exportId,
          importId: this.importId,
          potentialValue: item.potentialValue,
          exportValue: item.exportFactToCountry,
          importValue: item.importFromCountry,
        };
        Api.update(this.id, body)
          .then(() => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            this.$router.push({ name: 'ExportPotential' });
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          });
      },
      close() {
        this.$router.push({ name: 'ExportPotential' });
      },
    },
  };
</script>
